import { useParams, useLocation } from "react-router-dom";
import React from "react";
import Details from "./components/Details";
import OrderStatus from "./components/OrderStatus";
import Receipt from "./components/Receipt";
import { fetchSubscriptionDetails } from "api"; 
import { useQuery } from "@tanstack/react-query";

const OrderDetails = () => {
  const { orderId } = useParams();
  const location = useLocation();
  const userId = location.state?.userId;

  // Fetch subscription data using orderId (which is actually subscriptionId)
  const { data: subscriptionData, isLoading, isError, error } = useQuery({
    queryKey: ["subscriptionDetails", orderId],
    queryFn: () => fetchSubscriptionDetails(orderId),
    enabled: !!orderId, // Only runs this query if orderId is available
    onSuccess: (data) => {
      console.log("Subscription data received:", data);
    },
    onError: (error) => {
      console.error("Error fetching subscription data:", error);
      console.error("Error details:", error.response?.data);
      console.error("Error status:", error.response?.status);
    },
  });

  if (isLoading) return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-4 border-dashed border-orange-500 mx-auto mb-4"></div>
        <p className="text-gray-600">Loading subscription details...</p>
      </div>
    </div>
  );
  
  if (isError || !subscriptionData) return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
        <p className="text-red-600 mb-2">Error loading subscription data.</p>
        <p className="text-gray-600 mb-2">Please try again or contact support.</p>
        {error && (
          <div className="text-xs text-gray-500 mt-4 p-2 bg-gray-100 rounded">
            <p>Error: {error.message}</p>
            {error.response?.status && <p>Status: {error.response.status}</p>}
            {error.response?.data?.message && <p>Details: {error.response.data.message}</p>}
          </div>
        )}
      </div>
    </div>
  );

  // Prepare data for components
  const orderData = {
    id: subscriptionData.id,
    user: subscriptionData.user,
    course: subscriptionData.course,
    billing: subscriptionData.billing,
    status: subscriptionData.status,
    subscriptionType: subscriptionData.subscriptionType,
    createdAt: subscriptionData.createdAt,
    updatedAt: subscriptionData.updatedAt,
    expirationDate: subscriptionData.expirationDate,
    // Payment details
    paymentMethod: subscriptionData.billing?.paymentMethod || 'N/A',
    paymentDate: subscriptionData.billing?.paymentDate || subscriptionData.createdAt,
    accountReference: subscriptionData.billing?.accountReference || 'N/A',
    transactionId: subscriptionData.billing?.transactionId || 'N/A',
    amount: subscriptionData.billing?.amount || 0,
    discountAmount: subscriptionData.billing?.discountAmount || 0,
    totalPaid: subscriptionData.billing?.amount || 0,
    currency: subscriptionData.billing?.paymentMethod === 'WaafiPay' ? 'USD' : 'KES',
    // Course details
    courseTitle: subscriptionData.course?.title || 'Unknown Course',
  };

  console.log("Prepared orderData:", orderData);
  console.log("Raw subscriptionData:", subscriptionData);

  return (
    <div className="mt-3 grid h-full w-full grid-cols-7 gap-[20px] rounded-[20px]">
      <div className="z-0 col-span-7 lg:col-span-5">
        <Receipt orderData={orderData} />
      </div>
      <div className="z-0 col-span-7 lg:col-span-2">
        <OrderStatus orderData={orderData} />
      </div>
      <div className="z-0 col-span-7 lg:col-span-7">
        <Details orderData={orderData} />
      </div>
    </div>
  );
};

export default OrderDetails;

